import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-linen">
        <div className="w-12 h-12 rounded-full bg-brand/20 animate-breathe" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
